module.exports = __webpack_public_path__ + "static/media/papyrus_password_changed_icon.8f3cfa7d.svg";